export default __webpack_public_path__ + "static/media/red-x.0f39dd00.svg";